export const integrationTypes = {
    CUSTOM: 'CUSTOM'
};
